import React from "react"
import { Trans } from "@lingui/react"
import { useLingui } from "@lingui/react"

import PropTypes from "prop-types"

export const SuccessMessage = () => {
  return (
    <div style={successStyle}>
      <Trans id="success">Success</Trans>
    </div>
  )
}

export const ErrorMessage = () => {
  return (
    <div style={failStyle}>
      <Trans id="error">Error</Trans>
    </div>
  )
}

export const WarningMessage = ({ msg }) => {
  return (
    <div style={warningStyle}>
      <Trans id={msg}>{msg}</Trans>
    </div>
  )
}

const successStyle = {
  fontFamily: "quicksand",
  fontSize: "20px",
  color: "green",
  fontWeight: "bolder",
}

const failStyle = {
  fontFamily: "quicksand",
  fontSize: "20px",
  color: "red",
  fontWeight: "bolder",
}

const warningStyle = {
  fontFamily: "quicksand",
  fontSize: "20px",
  color: "blue",
  fontWeight: "bolder",
}

WarningMessage.propTypes = {
  msg: PropTypes.any,
}
